import ChoiceGroup from '../ChoiceGroup/ChoiceGroup';
import Choice from '../ChoiceGroup/Choice';
import {
  type FieldErrors,
  type UseFormRegister,
  type FieldValues,
  type Path,
} from 'react-hook-form';
import { MARKETING_OPT_OUT_FIELD_ID } from '../../../../../netlify/edge-functions/lead-cookies-geolocation';

type MarketingOptOutProps<TFieldValues extends FieldValues> = {
  label: string;
  errors: FieldErrors;
  register: UseFormRegister<TFieldValues>;
  productId?: string;
  disabled?: boolean;
};

const MarketingOptOut = <TFieldValues extends FieldValues>({
  label,
  errors,
  register,
  productId,
  disabled,
}: MarketingOptOutProps<TFieldValues>) => (
  <ChoiceGroup
    name={MARKETING_OPT_OUT_FIELD_ID}
    id={MARKETING_OPT_OUT_FIELD_ID}
    formGroupProps={{
      label,
      hideLabel: true,
    }}
    errors={errors}
  >
    <Choice
      id={`${MARKETING_OPT_OUT_FIELD_ID}_true`}
      type="checkbox"
      label={label}
      productId={productId ?? ''}
      disabled={disabled}
      {...register(MARKETING_OPT_OUT_FIELD_ID as Path<TFieldValues>)}
    />
  </ChoiceGroup>
);

export default MarketingOptOut;
